@if (eventName(); as eventName) {
    <app-event-restaurant-diagnostic-search [eventName]="eventName"></app-event-restaurant-diagnostic-search>
} @else {
    <app-main-restaurant-diagnostic-search></app-main-restaurant-diagnostic-search>
}
